import React from 'react';

export default function BTechPrivacy() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h1>Bulsho Tech – Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> August 15, 2025
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect your name, phone number, address, and other details for
        hospital appointments, blood donation registration, and second-hand
        product postings. For payments, we use secure third-party local payment
        providers and do not store your payment details.
      </p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Book hospital appointments and process payments</li>
        <li>Register blood donations</li>
        <li>Enable contact between buyers and sellers</li>
        <li>Improve our app services</li>
      </ul>

      <h2>3. How We Share Your Information</h2>
      <p>
        We do not sell your personal data. We may share it with hospitals, blood
        donation organizations, and buyers/sellers where necessary.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to protect your data but cannot guarantee
        100% security.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You can update or delete your personal data by contacting us at{' '}
        <a href="mailto:youremail@example.com">youremail@example.com</a>.
      </p>

      <h2>6. Third-Party Services</h2>
      <p>
        Our app may link to third-party services (payment gateways, WhatsApp).
        Their privacy practices may differ from ours.
      </p>

      <h2>7. Changes</h2>
      <p>
        We may update this policy from time to time. Updates will appear here
        and in our app.
      </p>
    </div>
  );
}
